export default __webpack_public_path__ + "static/signupFormImg-6ea4e150d8d99575cd1293caeb6ecfa2.png";